import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardBody, Button, ButtonGroup } from 'reactstrap';
import entityComposition from '../classes/entityComposition';
import checkBrowser from '../../../utils/checkBrowser';
import navigation from './navigation';
import Icon from '../containers/icon';
import DownloadButton from '../downloadButton';
import PDFWrapper from './pdfWrapper';
import AnnotationsEditBar from './annotationsEditBar';
import Loader from '../loader';
import DownloadDocumentButton from '../controls/downloadDocumentButton';
import { checkPermission, makeResource } from '../../../../behaviors/src/lib/permissions';
const initialZoomFactor = 1;
const maxZoomFactor = 3;

// must be defined outside of the component to avoid re-rendering loops
const defaultOnAnnotationSelect = () => {};
const defaultHandleTransition = () => {};
const defaultReportAnnotation = {};
const defaultIssueActions = {};
const PDF = _ref => {
  let annotation = _ref.annotation,
    annotationSelection = _ref.annotationSelection,
    annotationSelectionActions = _ref.annotationSelectionActions,
    _ref$src = _ref.src,
    src = _ref$src === void 0 ? null : _ref$src,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? null : _ref$button,
    _ref$nativeRenderer = _ref.nativeRenderer,
    nativeRenderer = _ref$nativeRenderer === void 0 ? false : _ref$nativeRenderer,
    _ref$hideTitleIfMobil = _ref.hideTitleIfMobile,
    hideTitleIfMobile = _ref$hideTitleIfMobil === void 0 ? false : _ref$hideTitleIfMobil,
    _ref$asyncDownloadPat = _ref.asyncDownloadPath,
    asyncDownloadPath = _ref$asyncDownloadPat === void 0 ? false : _ref$asyncDownloadPat,
    _ref$containerMaxHeig = _ref.containerMaxHeight,
    containerMaxHeight = _ref$containerMaxHeig === void 0 ? 1200 : _ref$containerMaxHeig,
    _ref$onAnnotationSele = _ref.onAnnotationSelect,
    onAnnotationSelect = _ref$onAnnotationSele === void 0 ? defaultOnAnnotationSelect : _ref$onAnnotationSele,
    _ref$enableEditAnnota = _ref.enableEditAnnotations,
    enableEditAnnotations = _ref$enableEditAnnota === void 0 ? false : _ref$enableEditAnnota,
    _ref$issueLoading = _ref.issueLoading,
    issueLoading = _ref$issueLoading === void 0 ? false : _ref$issueLoading,
    _ref$login = _ref.login,
    login = _ref$login === void 0 ? {} : _ref$login,
    _ref$reportAnnotation = _ref.reportAnnotation,
    reportAnnotation = _ref$reportAnnotation === void 0 ? defaultReportAnnotation : _ref$reportAnnotation,
    reportAnnotationActions = _ref.reportAnnotationActions,
    _ref$downloadPDFPath = _ref.downloadPDFPath,
    downloadPDFPath = _ref$downloadPDFPath === void 0 ? null : _ref$downloadPDFPath,
    _ref$clearDownload = _ref.clearDownload,
    clearDownload = _ref$clearDownload === void 0 ? null : _ref$clearDownload,
    _ref$download = _ref.download,
    download = _ref$download === void 0 ? null : _ref$download,
    _ref$preSelectedAnnot = _ref.preSelectedAnnotationTypeID,
    preSelectedAnnotationTypeID = _ref$preSelectedAnnot === void 0 ? null : _ref$preSelectedAnnot,
    _ref$handleTransition = _ref.handleTransition,
    handleTransition = _ref$handleTransition === void 0 ? defaultHandleTransition : _ref$handleTransition,
    _ref$issueActions = _ref.issueActions,
    issueActions = _ref$issueActions === void 0 ? defaultIssueActions : _ref$issueActions,
    _ref$clearSelection = _ref.clearSelection,
    clearSelection = _ref$clearSelection === void 0 ? undefined : _ref$clearSelection,
    _ref$evaluateAnnotati = _ref.evaluateAnnotationHandlerColor,
    evaluateAnnotationHandlerColor = _ref$evaluateAnnotati === void 0 ? null : _ref$evaluateAnnotati;
  // Get src from annotation state if not provided as prop
  const _ref2 = annotation || {},
    _ref2$editorState = _ref2.editorState,
    _ref2$editorState2 = _ref2$editorState === void 0 ? {} : _ref2$editorState,
    _ref2$editorState2$re = _ref2$editorState2.remotePath,
    _ref2$editorState2$re2 = _ref2$editorState2$re === void 0 ? {} : _ref2$editorState2$re,
    cachePath = _ref2$editorState2$re2._cache;
  const pdfSrc = src || cachePath;
  const annotationActive = annotation.active,
    _annotation$editorSta = annotation.editorState,
    _annotation$editorSta2 = _annotation$editorSta === void 0 ? {} : _annotation$editorSta,
    _annotation$editorSta3 = _annotation$editorSta2.toolbar,
    toolbar = _annotation$editorSta3 === void 0 ? null : _annotation$editorSta3;
  const annotationContext = annotationSelection.annotationContext,
    defaultColor = annotationSelection.defaultColor,
    selectableType = annotationSelection.selectableType;
  const setDefaultColor = annotationSelectionActions.setDefaultColor,
    setSelectableType = annotationSelectionActions.setSelectableType;
  const reportAnnotationActive = reportAnnotation.active,
    reportAnnotationLoading = reportAnnotation.loading;
  const selectByAnnotationTypeID = reportAnnotationActions.selectByAnnotationTypeID;
  const _useState = useState({
      zoomFactor: initialZoomFactor,
      hasZoomedToAnnotation: false,
      headerHeight: 59,
      heightMask: [],
      inView: 0,
      loading: false,
      isRendered: false,
      isZooming: false,
      containerKey: 0 // Simple counter to force re-render on container size changes
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    pdfData = _useState4[0],
    setPdfData = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    pdfError = _useState6[0],
    setPdfError = _useState6[1];
  const lastSrcRef = useRef(null);
  const pdfDataRef = useRef(null);
  const fetchingRef = useRef(false);
  const prevActiveIdRef = useRef(null);
  const hasZoomedToAnnotationRef = useRef(false);
  const activeRef = useRef(null);
  const isMountedRef = useRef(true);
  const initialRenderCompleteRef = useRef(false);
  const lastContainerKeyUpdateRef = useRef({
    width: 0,
    height: 0
  });
  const initialLoadCompleteRef = useRef(false);
  const pdfWrapperKeyRef = useRef(null);
  const pdfWrapperMountingRef = useRef(false);

  // Track header height and container size changes
  React.useLayoutEffect(() => {
    const container = global.document.getElementById('pdf-viewer-body');
    if (!container) {
      return undefined;
    }
    let prevWidth = container.offsetWidth;
    let prevHeight = container.offsetHeight;
    let resizeTimeout = null;
    const updateDimensions = () => {
      const header = global.document.getElementById('pdf-viewer-header');
      if (header && header.clientHeight && state.headerHeight !== header.clientHeight) {
        if (isMountedRef.current) {
          setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
            headerHeight: header.clientHeight
          }));
        }
      }

      // Check for significant container size changes
      const width = container.offsetWidth;
      const height = container.offsetHeight;
      const widthChange = Math.abs(width - prevWidth);
      const heightChange = Math.abs(height - prevHeight);

      // Only force re-render for significant size changes
      // (more than 50px for width, 100px for height)
      // and only after initial render is complete AND we're not loading
      // AND the change is not due to content loading (height increases are often content-related)
      const shouldUpdate = (widthChange > 50 || heightChange > 100) && initialRenderCompleteRef.current && initialLoadCompleteRef.current && !state.loading
      // Don't block container resize updates due to annotation selection pending state
      // && !state.annotationSelectionPending
      // Don't trigger on height increases during content loading
      && !(heightChange > 0 && height > prevHeight && !initialRenderCompleteRef.current);

      // Also check if we've already updated for this size to prevent repeated updates
      const alreadyUpdatedForThisSize = Math.abs(width - lastContainerKeyUpdateRef.current.width) < 5 && Math.abs(height - lastContainerKeyUpdateRef.current.height) < 10;
      if (shouldUpdate && !alreadyUpdatedForThisSize) {
        // Debounce resize events to prevent rapid re-renders
        if (resizeTimeout) {
          clearTimeout(resizeTimeout);
        }
        resizeTimeout = setTimeout(() => {
          if (isMountedRef.current) {
            setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
              containerKey: prev.containerKey + 1
            }));
            // Update the last container key update tracking
            lastContainerKeyUpdateRef.current = {
              width,
              height
            };
          }
          prevWidth = width;
          prevHeight = height;
        }, 100); // Reduced debounce to 100ms for more responsive resizing
      }
    };
    updateDimensions();
    const resizeObserver = new global.window.ResizeObserver(updateDimensions);
    resizeObserver.observe(container);
    return () => {
      resizeObserver.disconnect();
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
    };
  }, [state.headerHeight, state.loading, state.containerKey]);
  useEffect(() => {
    if (!pdfSrc) {
      return;
    }

    // If we're already fetching this src, don't start another fetch
    if (fetchingRef.current && lastSrcRef.current === pdfSrc) {
      // Keep loading state as true since fetch is in progress
      return;
    }

    // Reset PDF wrapper mounting refs if they don't match current src
    // This handles the case where src changed A→B→A and refs still reference B
    if (pdfWrapperKeyRef.current !== null && pdfWrapperKeyRef.current !== pdfSrc) {
      pdfWrapperMountingRef.current = false;
      pdfWrapperKeyRef.current = null;
    }

    // If src hasn't changed and we have data, do nothing
    // Check this AFTER fetching check and ref reset to ensure
    // refs are properly synchronized even if we have cached data
    if (lastSrcRef.current === pdfSrc && pdfDataRef.current) {
      // Ensure loading state is cleared since we already have the data
      // Only update state if loading is currently true to avoid unnecessary re-renders
      if (isMountedRef.current) {
        setState(prev => {
          if (prev.loading === false) {
            return prev; // No state change needed, return same state to prevent re-render
          }
          return _objectSpread(_objectSpread({}, prev), {}, {
            loading: false
          });
        });
      }
      return;
    }

    // Reset initial render flag for new PDF
    initialRenderCompleteRef.current = false;
    initialLoadCompleteRef.current = false;
    // Reset container key update tracking for new PDF
    lastContainerKeyUpdateRef.current = {
      width: 0,
      height: 0
    };
    // Reset PDF wrapper mounting refs when PDF source changes
    pdfWrapperMountingRef.current = false;
    pdfWrapperKeyRef.current = null;

    // Set rendering state to prevent container size tracking during PDF loading
    if (isMountedRef.current) {
      setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
        loading: true
      }));
    }

    // If src is a URL, fetch and cache as ArrayBuffer
    if (typeof pdfSrc === 'string' && pdfSrc.startsWith('http')) {
      fetchingRef.current = true;
      fetch(pdfSrc).then(res => res.arrayBuffer()).then(data => {
        // Use a more robust approach that doesn't rely on isMountedRef
        // since React 18 strict mode can cause unmounting during development
        fetchingRef.current = false;
        setPdfData(data);
        setPdfError(null);
        pdfDataRef.current = data;
        lastSrcRef.current = pdfSrc; // Set after pdfDataRef to maintain consistency
        setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
          loading: false
        }));
        initialLoadCompleteRef.current = true;
        pdfWrapperMountingRef.current = false;
      }).catch(error => {
        fetchingRef.current = false;
        pdfWrapperMountingRef.current = false;
        // eslint-disable-next-line no-console
        console.error('PDF: Failed to load PDF data', error);
        setPdfError(error);
        setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
          loading: false
        }));
      });
    } else if (isMountedRef.current) {
      // If src is already an ArrayBuffer, use directly
      if (pdfSrc instanceof ArrayBuffer) {
        setPdfData(pdfSrc);
        setPdfError(null);
        pdfDataRef.current = pdfSrc;
        lastSrcRef.current = pdfSrc;
        setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
          loading: false
        }));
        initialLoadCompleteRef.current = true;
      } else if (pdfSrc instanceof Uint8Array) {
        const arrayBuffer = pdfSrc.buffer.slice(pdfSrc.byteOffset, pdfSrc.byteOffset + pdfSrc.byteLength);
        setPdfData(arrayBuffer);
        setPdfError(null);
        pdfDataRef.current = arrayBuffer;
        lastSrcRef.current = pdfSrc;
        setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
          loading: false
        }));
        initialLoadCompleteRef.current = true;
      }
    }
  }, [pdfSrc]);

  // Cleanup effect to handle component unmounting
  useEffect(() => () => {
    isMountedRef.current = false;
  }, []);

  // Debug effect to track pdfData state changes
  useEffect(() => {
    // console.log('pdfData state changed:',
    //   pdfData ? `ArrayBuffer(${pdfData.byteLength})` : 'null');
  }, [pdfData]);

  // Effect to accurately track PDFWrapper mounting state
  // This prevents race conditions where refs are set during render
  // but React batches renders before PDFWrapper actually mounts.
  // The effect runs after render completes, ensuring accurate tracking of mounting state.
  useEffect(() => {
    if (pdfData) {
      // Set both refs after render commits to ensure accurate state tracking
      // This prevents race conditions with batched renders
      pdfWrapperKeyRef.current = pdfSrc;
      pdfWrapperMountingRef.current = true;
    }
  }, [pdfData, pdfSrc]);
  const viewerRef = React.useRef(null);
  const active = annotationContext === 'form' ? annotationActive : reportAnnotationActive;
  const updateScroll = useCallback(event => {
    setState(prev => {
      const heightMask = prev.heightMask,
        inView = prev.inView;
      let runner = 0;
      let knownIndex = 0;
      heightMask.forEach((height, index) => {
        if (!knownIndex && runner + height > event.target.scrollTop) {
          knownIndex = index;
        }
        runner += height;
      });
      if (inView !== knownIndex) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          inView: knownIndex
        });
      }
      return prev;
    });
  }, []);
  const onRenderComplete = useCallback(heightMask => {
    // Mark initial render as complete
    if (!initialRenderCompleteRef.current) {
      initialRenderCompleteRef.current = true;
    }

    // Only scroll to annotation if we haven't already zoomed to it
    if (activeRef.current && activeRef.current.id && !hasZoomedToAnnotationRef.current) {
      try {
        // Validate that the annotation has the required properties for scrolling
        const activeAnnotation = activeRef.current;
        if (!activeAnnotation.rectString || !activeAnnotation.pageNumber) {
          hasZoomedToAnnotationRef.current = true; // Mark as attempted to prevent retries
          return;
        }
        navigation.scrollAnnotationIntoView(activeAnnotation);
        hasZoomedToAnnotationRef.current = true;
      } catch (error) {
        hasZoomedToAnnotationRef.current = true; // Mark as attempted to prevent retries
      }
    }
    const header = global.document.getElementById('pdf-viewer-header');

    // Only update state if something actually changed to prevent infinite loops
    setState(prev => {
      const newHeaderHeight = header && header.clientHeight ? header.clientHeight : 59;

      // Optimize heightMask comparison by checking length and content more efficiently
      const heightMaskChanged = prev.heightMask.length !== heightMask.length || prev.heightMask.some((height, index) => height !== heightMask[index]);
      const needsUpdate = prev.headerHeight !== newHeaderHeight || prev.hasZoomedToAnnotation !== hasZoomedToAnnotationRef.current || prev.loading !== false || prev.isZooming !== false || heightMaskChanged;
      if (!needsUpdate) {
        return prev; // Return same state to prevent rerender
      }
      return _objectSpread(_objectSpread({}, prev), {}, {
        headerHeight: newHeaderHeight,
        hasZoomedToAnnotation: hasZoomedToAnnotationRef.current,
        loading: false,
        isZooming: false,
        heightMask
      });
    });
  }, [setState]); // Add setState as dependency to make the callback more stable

  const onDocumentError = useCallback(error => {
    setPdfError(error);
  }, []);
  const setSelectable = useCallback(compositeType => {
    // Parse the composite type to extract renderType and formTypeIdentifier
    let renderType = compositeType;
    let formTypeIdentifier = null;
    if (compositeType && compositeType.includes('__')) {
      const parts = compositeType.split('__');
      renderType = parts[0];
      formTypeIdentifier = parts[1];
    }
    handleTransition(() => {
      // Gate edit mode for form annotations only; leave report/legacy unchanged
      let allowAnnotationsEdit = true;
      if ((annotationSelection === null || annotationSelection === void 0 ? void 0 : annotationSelection.annotationContext) === 'form') {
        var _login$user;
        allowAnnotationsEdit = checkPermission(makeResource('form', formTypeIdentifier), ['edit', 'create', 'view_detail'], login === null || login === void 0 || (_login$user = login.user) === null || _login$user === void 0 ? void 0 : _login$user.permissions, login === null || login === void 0 ? void 0 : login.user);
      }
      if (renderType !== null && compositeType !== selectableType && typeof clearSelection === 'function') {
        clearSelection();
      }
      if (compositeType === null || compositeType === 'issue') {
        issueActions.showCancel();
      }
      setSelectableType(compositeType, allowAnnotationsEdit);
    });
  }, [handleTransition, issueActions, setSelectableType, clearSelection, selectableType, annotationSelection === null || annotationSelection === void 0 ? void 0 : annotationSelection.annotationContext, login === null || login === void 0 ? void 0 : login.user]);
  const changeZoom = useCallback(newZoomFactor => {
    // Don't use `const { zoomFactor } = state;` since it's from the closure,
    // not the latest state. This can cause bugs if multiple zooms happen quickly,
    // as React state updates are asynchronous. The correct pattern is to use the
    // functional form of setState and reference prev.zoomFactor
    setState(prev => {
      const newZoom = prev.zoomFactor + newZoomFactor;
      let normalized = Math.min(newZoom, maxZoomFactor);
      normalized = Math.max(normalized, 0.25);
      return _objectSpread(_objectSpread({}, prev), {}, {
        zoomFactor: normalized,
        isZooming: true
      });
    });
  }, []);
  const resetZoom = useCallback(() => {
    const zoomFactor = state.zoomFactor;
    if (zoomFactor !== initialZoomFactor) {
      setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
        zoomFactor: initialZoomFactor,
        isZooming: true
      }));
    }
  }, [state]);
  useEffect(() => {
    viewerRef.current = global.document.getElementById('pdf-viewer-body');
    if (viewerRef.current) {
      viewerRef.current.addEventListener('scroll', updateScroll);
    }
    if (preSelectedAnnotationTypeID) {
      selectByAnnotationTypeID(preSelectedAnnotationTypeID);
    }
    return () => {
      if (viewerRef.current) {
        viewerRef.current.removeEventListener('scroll', updateScroll);
      }
    };
  }, [preSelectedAnnotationTypeID, selectByAnnotationTypeID, updateScroll]);

  // Add effect to handle active annotation changes
  useEffect(() => {
    const currentActiveId = active === null || active === void 0 ? void 0 : active.id;
    const prevActiveId = prevActiveIdRef.current;

    // Update the active ref
    activeRef.current = active;

    // Skip if no active annotation
    if (!currentActiveId || !active) {
      return;
    }

    // Skip if it's the same annotation ID
    if (currentActiveId === prevActiveId) {
      prevActiveIdRef.current = currentActiveId;
      return;
    }

    // Only force rerender if active annotation ID actually changed AND we have a valid annotation
    if (currentActiveId && currentActiveId !== prevActiveId && active && active.id) {
      // Only update state if something actually needs to change
      setState(prev => {
        const needsUpdate = prev.hasZoomedToAnnotation !== false;
        if (!needsUpdate) {
          return prev; // Return same state to prevent rerender
        }
        return _objectSpread(_objectSpread({}, prev), {}, {
          hasZoomedToAnnotation: false
          // Don't increment pdfKey - let PDFWrapper handle annotation changes internally
        });
      });
      prevActiveIdRef.current = currentActiveId;
      hasZoomedToAnnotationRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active === null || active === void 0 ? void 0 : active.id]); // Use active?.id instead of active to prevent rerenders when
  // object reference changes but ID stays the same

  const isMobileOS = checkBrowser.isMobile();
  const hideTitle = hideTitleIfMobile && isMobileOS;
  const titleComponent = hideTitle ? null : /*#__PURE__*/React.createElement("h3", {
    className: "t-pdf-title"
  }, title);
  const callDownload = () => {
    if (download !== null) {
      download();
    }
  };
  const callClearDownload = () => {
    if (clearDownload !== null) {
      clearDownload();
    }
  };
  if (nativeRenderer && !isMobileOS) {
    return /*#__PURE__*/React.createElement("object", {
      title: title,
      className: "t-doc-pdf",
      frameBorder: 0,
      width: "100%",
      height: containerMaxHeight,
      data: pdfSrc,
      type: "application/pdf",
      style: {
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
      }
    }, /*#__PURE__*/React.createElement(DownloadButton, {
      url: pdfSrc,
      documentTitle: title,
      buttonText: "Download PDF"
    }));
  }
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      width: '100%',
      height: containerMaxHeight,
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    id: "pdf-viewer-header",
    style: {
      paddingLeft: 10,
      paddingBottom: 9,
      paddingRight: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      float: 'left',
      paddingTop: 4
    }
  }, button || titleComponent), /*#__PURE__*/React.createElement("div", {
    style: {
      float: 'left',
      paddingLeft: 15,
      paddingTop: 8
    }
  }, button ? titleComponent : null), /*#__PURE__*/React.createElement("div", {
    style: {
      float: 'right'
    }
  }, state.isZooming ? /*#__PURE__*/React.createElement("span", {
    className: "miniLoader"
  }) : null, enableEditAnnotations ? /*#__PURE__*/React.createElement(AnnotationsEditBar, {
    setEditType: setSelectable,
    selectedType: selectableType,
    selectedColor: defaultColor,
    setEditColor: setDefaultColor,
    toolbar: toolbar,
    user: login === null || login === void 0 ? void 0 : login.user
  }) : null, /*#__PURE__*/React.createElement(ButtonGroup, {
    style: {
      paddingRight: 10,
      paddingLeft: 10
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: "t-pdf-zoom-out",
    onClick: () => changeZoom(-0.25)
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "search-minus"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "t-pdf-zoom-reset",
    onClick: resetZoom
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "search"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "t-pdf-zoom-in",
    onClick: () => changeZoom(0.25)
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "search-plus"
  }))), /*#__PURE__*/React.createElement(DownloadDocumentButton, {
    disabled: state.loading || reportAnnotationLoading || issueLoading,
    downloadPath: asyncDownloadPath ? downloadPDFPath : pdfSrc,
    loadPDF: callDownload,
    clearSelection: callClearDownload,
    className: "float-md-right pull-down form-control"
  }))), /*#__PURE__*/React.createElement(CardBody, {
    id: "pdf-viewer-body",
    style: {
      flex: 1,
      overflow: 'auto',
      backgroundColor: 'DimGrey',
      padding: '5px'
    }
  }, /*#__PURE__*/React.createElement(Loader, {
    loaded: !state.loading
  }, (() => {
    if (pdfError) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center',
          padding: '20px',
          color: 'red'
        }
      }, "Failed to load PDF: ", pdfError.message || 'Unknown error');
    }
    if (pdfData) {
      // Prevent mounting multiple PDFWrappers if one is already mounting
      // This helps prevent duplicate pages when pdfSrc changes rapidly
      // Note: refs are managed in useEffect after render commits to avoid race conditions
      if (pdfWrapperMountingRef.current && pdfWrapperKeyRef.current !== pdfSrc) {
        return /*#__PURE__*/React.createElement(Loader, null);
      }
      return /*#__PURE__*/React.createElement(PDFWrapper, {
        key: "".concat(pdfSrc, "-").concat(state.containerKey),
        pageInView: state.inView,
        className: "pdf-document",
        zoomFactor: state.zoomFactor,
        file: pdfData,
        selected: active,
        onRenderComplete: onRenderComplete,
        onAnnotationSelect: onAnnotationSelect,
        onDocumentError: onDocumentError,
        evaluateAnnotationHandlerColor: evaluateAnnotationHandlerColor
      });
    }
    return /*#__PURE__*/React.createElement(Loader, null);
  })())));
};
PDF.propTypes = {
  annotation: PropTypes.shape({
    active: PropTypes.shape({
      id: PropTypes.string,
      rectString: PropTypes.string,
      pageNumber: PropTypes.number
    }),
    editorState: PropTypes.shape({
      toolbar: PropTypes.shape({})
    })
  }).isRequired,
  annotationSelection: PropTypes.shape({
    annotationContext: PropTypes.string,
    defaultColor: PropTypes.string,
    selectableType: PropTypes.string
  }).isRequired,
  annotationSelectionActions: PropTypes.shape({
    setDefaultColor: PropTypes.func,
    setSelectableType: PropTypes.func
  }).isRequired,
  downloadPDFPath: PropTypes.string,
  download: PropTypes.func,
  hideTitleIfMobile: PropTypes.bool,
  asyncDownloadPath: PropTypes.bool,
  clearDownload: PropTypes.func,
  preSelectedAnnotationTypeID: PropTypes.string,
  enableEditAnnotations: PropTypes.bool,
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(ArrayBuffer)]),
  title: PropTypes.string,
  nativeRenderer: PropTypes.bool,
  containerMaxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  issueLoading: PropTypes.bool,
  reportAnnotation: PropTypes.shape({
    active: PropTypes.shape({
      id: PropTypes.string
    }),
    loading: PropTypes.bool
  }),
  reportAnnotationActions: PropTypes.shape({
    selectByAnnotationTypeID: PropTypes.func
  }).isRequired,
  reportDocument: PropTypes.shape({
    reportDocumentID: PropTypes.string
  }),
  reportDocumentActions: PropTypes.shape({
    serverRenderAnnotatedDocument: PropTypes.func
  }),
  issueActions: PropTypes.shape({
    showCancel: PropTypes.func
  }),
  onAnnotationSelect: PropTypes.func,
  button: PropTypes.shape({}),
  handleTransition: PropTypes.func,
  clearSelection: PropTypes.func,
  evaluateAnnotationHandlerColor: PropTypes.func,
  login: PropTypes.shape({
    user: PropTypes.shape({
      permissions: PropTypes.shape({})
    })
  })
};
export { PDF as TestPDF };
export default entityComposition(PDF, ['annotation', 'annotationSelection', 'reportAnnotation', 'reportDocument', 'login'], {
  issueLoading: state => state.issue.loading
}, ['issue']);